import { ConfigRoutes, UniverseReference } from '../types/commons';

import { isCleaningReference, isWellnessReference } from './universes';

export const getTermsUrl = (universe: UniverseReference, routes?: ConfigRoutes) => {
  if (isWellnessReference(universe) && routes?.terms_of_service_wellness) {
    return routes.terms_of_service_wellness;
  }
  if (isCleaningReference(universe) && routes?.terms_of_service_care) return routes.terms_of_service_care;
  return routes?.terms_of_service;
};
